import textHelper from '@utils/textHelper';

const AMT_KEYS = {
  TAX_BREAKDOWN: 'tax_breakdown',
  TAX_BREAKDOWN_WITH_CREDITS: 'tax_breakdown_with_credits'
};

export const getTotalAmtBySubscription = (subscription = {}, withCredits) => {
  const taxBreakdown = withCredits
    ? AMT_KEYS.TAX_BREAKDOWN_WITH_CREDITS
    : AMT_KEYS.TAX_BREAKDOWN;
  return (
    Number(
      subscription[taxBreakdown]?.find((item) => item.label === 'Total')?.amount
    ) || 0
  );
};

export const getPMAmtBySubscription = (subscription, TotalForDays) => {
  const currency = textHelper.currencySymbolMap(subscription.currency);
  if (subscription.duration < 30) {
    const finalAmt = TotalForDays
      ? textHelper.commas(Math.round(getTotalAmtBySubscription(subscription)))
      : '';
    return finalAmt ? `${currency}${finalAmt}` : '';
  }

  const perMonthAmount = textHelper.commas(
    Math.round(subscription.display_data?.unit_price?.value)
  );
  return `${currency}${perMonthAmount}`;
};

export const getPMUnitBySubscription = (subscription, DaysUnitLabel) => {
  if (subscription.duration < 30) {
    return DaysUnitLabel || '';
  }
  return ` ${subscription.display_data?.unit_price?.unit || 'per month'}`;
};

export const getPMlabelBySubscription = (subscription = {}) => {
  return `${getPMAmtBySubscription(subscription)}${getPMUnitBySubscription(
    subscription,
    'Total'
  )}`;
};
